import { ChartServiceOptions } from '@shared/highcharts/char-service-options';
import { ChartPointOptions } from '@shared/highcharts/chart-point-options';
import { Point } from 'highcharts';

export function unselectHandler(this: Point): void {
  const unselectedOption = this.options as ChartPointOptions;
  const unselectedCountryCode = unselectedOption['hc-key'];
  const selectedCountryCodeInstance = (
    this.series.chart.options.chart as ChartServiceOptions
  ).selectedCountryCode;

  if (unselectedCountryCode === selectedCountryCodeInstance()) {
    selectedCountryCodeInstance.set(undefined);
  }
}
